export default "__VITE_ASSET__CAZGyzN3__"